import { render, staticRenderFns } from "./AddSaleServiceOrder.vue?vue&type=template&id=395d5bf2&scoped=true&"
import script from "./AddSaleServiceOrder.vue?vue&type=script&lang=js&"
export * from "./AddSaleServiceOrder.vue?vue&type=script&lang=js&"
import style0 from "./AddSaleServiceOrder.vue?vue&type=style&index=0&id=395d5bf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395d5bf2",
  null
  
)

export default component.exports